import moment from "moment";
import { ToWords } from "to-words";

export const getErrorMessage = (err) => {
  return err?.response?.data?.message || err.message;
};

export const getSuccessMessage = (res) => {
  return res?.message || "Success";
};

export const converter = new ToWords({
  localeCode: "en-IN",
  converterOptions: {
    currency: true,
    ignoreDecimal: false,
    ignoreZeroCurrency: false,
    doNotAddOnly: false,
    currencyOptions: {
      name: "Rupee",
      plural: "Rupees",
      symbol: "₹",
      fractionalUnit: {
        name: "Paisa",
        plural: "Paise",
        symbol: "",
      },
    },
  },
});

function groupItemsByHsnCode(items) {
  return items?.reduce((acc, item) => {
    const existingItem = acc.find((i) => i.hsnCode === item.hsnCode);
    if (existingItem) {
      existingItem.amountBeforeTax += item.amountBeforeTax;
      existingItem.cgstAmount += item.cgstAmount;
      existingItem.igstAmount += item.igstAmount;
      existingItem.sgstAmount += item.sgstAmount;
    } else {
      acc.push({
        hsnCode: item.hsnCode,
        sgst: item.sgst,
        cgst: item.cgst,
        igst: item.igst,
        amountBeforeTax: item.amountBeforeTax,
        cgstAmount: item.cgstAmount,
        igstAmount: item.igstAmount,
        sgstAmount: item.sgstAmount,
      });
    }
    return acc;
  }, []);
}

const getFormattedBillingDate = (date) => {
  return moment(date).format("DD/MM/YYYY");
};
export const invoicePDFTemplate2 = (invoice, copyType) => {
  if (!invoice) return;
  const {
    companyDetails,
    invoiceNumber,
    invoiceDate,
    stateOfSupply,
    eWayBillNo = "",
    customerDetails,
    items,
    transport,
    vehicle,
    station,
    isPreview = false,
  } = invoice;

  const {
    address = "",
    phoneNumber = "",
    gst = "",
    name = "",
  } = customerDetails ?? {};

  let totalAmountBeforeTax = 0;
  let totalSgstAmount = 0;
  let totalCgstAmount = 0;
  let totalIgstAmount = 0;
  let totalGrandTotal = 0;

  items?.forEach((item) => {
    item.amountBeforeTax = +item.quantity * +item.price;
    item.sgstAmount = +item.amountBeforeTax * (item.sgst / 100);
    item.cgstAmount = +item.amountBeforeTax * (item.cgst / 100);
    item.igstAmount = +item.amountBeforeTax * (item.igst / 100) || 0;
    item.grandTotal =
      +item.amountBeforeTax * (+item.cgst / 100) +
      +item.amountBeforeTax * (+item.sgst / 100) +
      (+item.amountBeforeTax * (+item.igst / 100) || 0) +
      +item.amountBeforeTax;
    totalAmountBeforeTax += +item.amountBeforeTax;
    totalSgstAmount += +item.sgstAmount;
    totalCgstAmount += +item.cgstAmount;
    totalIgstAmount += +item.igstAmount || 0;
    totalGrandTotal += +item.grandTotal;
  });
  const groupedItems = groupItemsByHsnCode(items);

  const nonPreviewStyles = isPreview
    ? ""
    : `
    html, body {
      margin: 0;
      padding: 0;
    }
    body {
      font-family: 'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
      padding: 0px;
      line-height: 1.5;
    }
  `;

  return `<!DOCTYPE html>
    <html lang="en">
    <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>${name}</title>
        <style>
        ${nonPreviewStyles}
        
        * {
          box-sizing: border-box;
        }
        
        .container {
          border: 2px solid #2563eb;
          padding: 24px;
          background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
          max-width: 210mm;
          margin: 0 auto;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
        }
        
        .header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 14px;
          font-weight: 600;
          margin-bottom: 20px;
          padding: 12px 16px;
          background: #1e40af;
          color: white;
          border-radius: 8px;
        }
        
        .header p {
          margin: 0;
        }
        
        .stamp {
          text-align: center;
          margin-bottom: 24px;
          padding: 20px;
          background: white;
          border-radius: 12px;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }
        
        .stamp .para {
          font-weight: 600;
          margin: 8px 0;
          color: #1f2937;
        }
        
        .company_name {
          color: #dc2626;
          font-size: 24px;
          font-weight: 700;
          margin: 12px 0;
          text-transform: uppercase;
          letter-spacing: 1px;
        }
        
        .address {
          font-size: 14px;
          margin: 6px 0;
          color: #4b5563;
        }
        
        .box-parent {
          display: flex;
          justify-content: space-between;
          margin-bottom: 24px;
          gap: 16px;
        }
        
        .box-div {
          border: 1px solid #d1d5db;
          width: 48%;
          border-radius: 8px;
          background: white;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        }
        
        .list {
          padding: 16px;
          font-size: 14px;
          display: flex;
          flex-direction: column;
        }
        
        .list i {
          font-style: italic;
          margin-bottom: 8px;
          color: #6b7280;
          font-weight: 600;
        }
        
        .list p {
          margin: 6px 0;
          color: #374151;
        }
        
        .table_container {
          margin: 24px 0;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }
        
        table {
          font-family: 'Inter', sans-serif;
          border-collapse: collapse;
          width: 100%;
          font-size: 13px;
          background: white;
        }
        
        table th, table td {
          border: 1px solid #e5e7eb;
          padding: 12px 8px;
          text-align: center;
          vertical-align: middle;
        }
        
        table th {
          background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
          color: white;
          font-weight: 600;
          text-transform: uppercase;
          font-size: 12px;
          letter-spacing: 0.5px;
        }
        
        table tbody tr:nth-child(even) {
          background: #f9fafb;
        }
        
        table tbody tr:hover {
          background: #eff6ff;
          transition: background-color 0.2s ease;
        }
        
        table tbody tr:last-child {
          background: #fef3c7;
          font-weight: 600;
        }
        
        table tbody tr:last-child td {
          border-top: 2px solid #f59e0b;
        }
        
        .bank_container {
          background: white;
          padding: 20px;
          border-radius: 8px;
          margin: 24px 0;
          border-left: 4px solid #10b981;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }
        
        .bank_container p {
          font-weight: 500;
          font-size: 14px;
          margin: 8px 0;
          color: #374151;
        }
        
        .pdf-footer {
          display: flex;
          width: 100%;
          gap: 16px;
          margin-top: 24px;
        }
        
        .terms {
          border: 1px solid #d1d5db;
          padding: 16px;
          width: 50%;
          border-radius: 8px;
          background: white;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        }
        
        .terms_heading {
          text-decoration: underline;
          font-weight: 600;
          font-size: 16px;
          color: #1f2937;
          margin-bottom: 12px;
        }
        
        .for_heading {
          font-weight: 600;
          font-size: 14px;
          color: #374151;
        }
        
        .signature_div {
          min-height: 80px;
          border-bottom: 1px solid #d1d5db;
          margin-bottom: 16px;
        }
        
        .disclaimer {
          text-align: center;
          font-size: 12px;
          color: #6b7280;
          font-style: italic;
          margin-top: 16px;
          padding: 12px;
          background: #f3f4f6;
          border-radius: 6px;
        }
        
        p {
          font-size: 14px;
          line-height: 1.5;
        }
        
        h5 {
          font-size: 16px;
          font-weight: 600;
          color: #1f2937;
          margin: 16px 0;
          text-align: center;
          background: #fef3c7;
          padding: 12px;
          border-radius: 6px;
          border: 1px solid #f59e0b;
        }
        
        hr {
          border: none;
          height: 2px;
          background: linear-gradient(90deg, #3b82f6, #1d4ed8);
          margin: 20px 0;
          border-radius: 1px;
        }
        
        @media print {
          .container {
            border: 1px solid #000;
            box-shadow: none;
          }
          
          table th {
            background: #f3f4f6 !important;
            color: #000 !important;
          }
        }
        </style>
    </head>
    <body>
        <div class="container">
            <div class="header">
                <p>GSTIN: <strong>${companyDetails?.gst || ""}</strong></p>
                <p>${copyType}</p>
            </div>
            
            <div class="stamp">
                <p class="para">${invoice?.billType?.toUpperCase() || ""}</p>
                <p class="company_name para">${
                  companyDetails?.businessName || ""
                }</p>
                <p class="address">${companyDetails?.address || ""}</p>
                <p class="address">Mobile: ${
                  companyDetails?.phoneNumber || ""
                }</p>
                <p class="address">Email: ${companyDetails?.email || ""}</p>
            </div>
            
            <hr>
            
            <div class="box-parent">
                <div class="box-div">
                    <div class="list">
                        <p><strong>Invoice No:</strong> ${
                          invoiceNumber || ""
                        }</p>
                        <p><strong>Date of Invoice:</strong> ${getFormattedBillingDate(
                          invoiceDate
                        )}</p>
                        <p><strong>State of Supply:</strong> ${
                          stateOfSupply || ""
                        }</p>
                    </div>
                </div>
                <div class="box-div">
                    <div class="list">
                        <p><strong>Transport:</strong> ${transport || ""}</p>
                        <p><strong>Vehicle:</strong> ${vehicle || ""}</p>
                        <p><strong>Station:</strong> ${station || ""}</p>
                        <p><strong>E-Way Bill No:</strong> ${
                          eWayBillNo || ""
                        }</p>
                    </div>
                </div>
            </div>
            
            <div class="box-parent">
                <div class="box-div">
                    <div class="list">
                        <i>Billed to:</i>
                        <p><strong>${name || ""}</strong></p>
                        <p>${address || ""}</p>
                        <p>Mobile: ${phoneNumber || ""}</p>
                        <p>GSTIN/UIN: ${gst || ""}</p>
                    </div>
                </div>
                <div class="box-div">
                    <div class="list">
                        <i>Shipped to:</i>
                        <p><strong>${name}</strong></p>
                        <p>${address}</p>
                        <p>Mobile: ${phoneNumber}</p>
                        <p>GSTIN/UIN: ${gst}</p>
                    </div>
                </div>
            </div>
            <div class="table_container">
                <table>
                    <thead>
                        <tr>
                            <td>S.No</td>
                            <td>Particulars</td>
                            <td>HSN Code</td>
                            <td style="width: 10px;">Warranty (in months)</td>
                            <td>Qty.</td>
                            <td>Rate</td>
                            <td>Amount</td>
                            <td colspan="2">SGST Amount</td>
                            <td colspan="2">CGST Amount</td>
                            <td colspan="2">IGST Amount</td>
                            <td>Grand Total</td>
                        </tr>
                    </thead>
                    <tbody>
                        ${
                          items
                            ?.map(
                              (item, index) => `
                            <tr>
                                <td>${index + 1}</td>
                                <td>${item.name}</td>
                                <td>${item.hsnCode}</td>
                                <td>${item.warranty || 0}</td>
                                <td>${+item.quantity || 0}</td>
                                <td>${
                                  Number.parseFloat(item.price).toFixed(2) || 0
                                }</td>
                                <td>${
                                  +item.amountBeforeTax.toFixed(2) || 0
                                }</td>
                                <td>${+item.sgst || 0}</td>
                                <td>${+item.sgstAmount.toFixed(2)}</td>
                                <td>${+item.cgst || 0}</td>
                                <td>${+item.cgstAmount.toFixed(2) || 0}</td>
                                <td>${+item.igst || 0}</td>
                                <td>${+item.igstAmount.toFixed(2) || 0}</td>
                                <td>${+item.grandTotal.toFixed(2) || 0}</td>
                            </tr>
                        `
                            )
                            .join("") || ""
                        }
                        <tr>
                            <td colspan="6">Total</td>
                            <td>${totalAmountBeforeTax.toFixed(2)}</td>
                            <td colspan="2">${totalSgstAmount.toFixed(2)}</td>
                            <td colspan="2">${totalCgstAmount.toFixed(2)}</td>
                            <td colspan="2">${totalIgstAmount.toFixed(2)}</td>
                            <td>${totalGrandTotal.toFixed(2)}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="table_container" id="2">
                <table>
                    <thead>
                        <tr>
                            <td>HSN/SAC</td>
                            <td>Tax Rate</td>
                            <td>Taxable Amount</td>
                            <td style="width: 10px;">CGST Amount</td>
                            <td style="width: 10px;">IGST Amount</td>
                            <td style="width: 10px;">SGST Amount</td>
                            <td>Total tax</td>
                        </tr>
                    </thead>
                    <tbody>
                    ${
                      groupedItems
                        ?.map(
                          (item, index) => `
                    <tr key=${index}>
                        <td>${item.hsnCode}</td>
                        <td>${(
                          Number(item?.sgst ?? 0) +
                          Number(item?.cgst ?? 0) +
                          Number(item?.igst ?? 0)
                        ).toFixed(2)}</td>
                        <td>${item.amountBeforeTax.toFixed(2)}</td>
                        <td>${item.cgstAmount.toFixed(2)}</td>
                        <td>${item.igstAmount.toFixed(2) || 0}</td>
                        <td>${item.sgstAmount.toFixed(2)}</td>
                        <td>${(
                          item.cgstAmount +
                          item.sgstAmount +
                          Number(item.igstAmount ?? 0)
                        ).toFixed(2)}</td>
                    </tr>
                `
                        )
                        .join("") || ""
                    }
                        <tr>
                            <td>Totals</td>
                            <td></td>
                            <td>${totalAmountBeforeTax.toFixed(2)}</td>
                            <td>${totalCgstAmount.toFixed(2)}</td>
                            <td>${totalIgstAmount.toFixed(2)}</td>
                            <td>${totalSgstAmount.toFixed(2)}</td>
                            <td>${totalGrandTotal.toFixed(2)}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <h5>${converter.convert(totalGrandTotal)}</h5>
            <div class="bank_container">
                <h4 style="margin-top: 0; color: #10b981;">Bank Details</h4>
                <p><strong>Bank Name:</strong> ${companyDetails?.bankName}</p>
                <p><strong>IFSC Code:</strong> ${companyDetails?.ifscCode}</p>
                <p><strong>Account Number:</strong> ${
                  companyDetails?.bankAccountNumber
                }</p>
                <p><strong>Branch:</strong> ${companyDetails?.bankBranch}</p>
            </div>
            <div class="pdf-footer">
                <div class="terms">
                    <h5 class="terms_heading">Terms & Conditions</h5>
                    <p>E. & E.O.</p>
                    <p>1) Goods once sold will not be taken back</p>
                    <p>2) Interest @18% p.a. will be charged if the payment is not made within the stipulated time.</p>
                    <p>3) Subject to '${
                      companyDetails?.jurisdiction
                    }' Jurisdiction only.</p>
                </div>
                <div class="terms">
                    <div class="signature_div">
                        <h5 class="terms_heading">Receiver's Signature</h5>
                    </div>
                    <div>
                        <h5 class="for_heading">for ${
                          companyDetails?.businessName
                        }</h5>
                        <div style="height: 60px;"></div>
                        <p class="for_heading">Authorised Signatory</p>
                    </div>
                </div>
            </div>
            
            <div class="disclaimer">
                <p>**This is computer generated invoice no signature required**</p>
            </div>
        </div>
    </body>
    </html>`;
};

export const invoicePDFTemplate = (invoice, copyType) => {
  if (!invoice) return;
  const {
    companyDetails,
    invoiceNumber,
    invoiceDate,
    stateOfSupply,
    eWayBillNo = "",
    customerDetails,
    items,
    transport,
    vehicle,
    station,
    isPreview = false,
  } = invoice;

  const {
    address = "",
    phoneNumber = "",
    gst = "",
    name = "",
  } = customerDetails ?? {};

  let totalAmountBeforeTax = 0;
  let totalSgstAmount = 0;
  let totalCgstAmount = 0;
  let totalIgstAmount = 0;
  let totalGrandTotal = 0;

  items?.forEach((item) => {
    item.amountBeforeTax = +item.quantity * +item.price;
    item.sgstAmount = +item.amountBeforeTax * (item.sgst / 100);
    item.cgstAmount = +item.amountBeforeTax * (item.cgst / 100);
    item.igstAmount = +item.amountBeforeTax * (item.igst / 100) || 0;
    item.grandTotal =
      +item.amountBeforeTax * (+item.cgst / 100) +
      +item.amountBeforeTax * (+item.sgst / 100) +
      (+item.amountBeforeTax * (+item.igst / 100) || 0) +
      +item.amountBeforeTax;
    totalAmountBeforeTax += +item.amountBeforeTax;
    totalSgstAmount += +item.sgstAmount;
    totalCgstAmount += +item.cgstAmount;
    totalIgstAmount += +item.igstAmount || 0;
    totalGrandTotal += +item.grandTotal;
  });
  const groupedItems = groupItemsByHsnCode(items);

  const nonPreviewStyles = isPreview
    ? ""
    : `
    html, body {
      margin: 0;
      padding: 0;
    }
    body {
      font-family: 'Roboto', sans-serif;
      padding: 0px;
    }
  `;

  return `<!DOCTYPE html>
    <html lang="en">
    <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>${name}</title>
        <style>
        .pdf-flex {
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
  
        flex-direction: column;
    }
  
    .box-parent {
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
  
        flex-direction: column;
    }
  
    .pdf-footer {
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        width: 95%;
    }
    ${nonPreviewStyles}
        
            .container {
                border: 1px solid orange;
                padding: 10px;
               
                background-color: #f8f8f8;
            }
            .header {
              display: -webkit-box;
  
                align-items: center;
                font-size: 14px;
                width:100%;
                margin-bottom: 20px;
  
            }
  
            .header p {
                margin: 0;
            }
  
            .stamp {
                text-align: center;
                margin-bottom: 20px;
                font-size: 18px;
            }
  
            .stamp .para {
                font-weight:500;
                margin: 5px 0;
            }
  
            .company_name {
                color: red;
                font-size: 18px;
                margin-bottom: 10px;
            }
  
            .address {
                font-size: 14px;
                margin-bottom: 5px;
            }
  
            .box-parent {
                justify-content: space-between;
                margin-bottom: 20px;
            }
  
            .box-div {
                border: 1px solid black;
                width: 50%;
            }
            .list {
                padding: 10px;
                font-size: 14px;
  
  
                flex-direction: column;
            }
  
            .list i {
                font-style: italic;
                margin-bottom: 5px;
            }
  
            .list p {
                margin: 5px 0;
            }
  
            .table_container {
                text-align: center;
                margin-top: 16px;
            }
  
            table {
                font-family: Arial, Helvetica, sans-serif;
                border-collapse: collapse;
                width: 100%;
                font-size: 14px;
            }
  
            table th, table td {
                border: 1px solid #ddd;
                padding: 8px;
            }
  
            table th {
                background-color: #f2f2f2;
            }
  
            table tr:nth-child(even) {
                background-color: #f2f2f2;
            }
  
            table tr:hover {
                background-color: #ddd;
            }
            .bank_container
            {
                font-weight: 500;
                font-size: 14px;
            }
            .terms{
                border:1px solid black;
              padding: 10px;
                width:50%;
            }
            .terms_heading{
                text-decoration: underline;
                font-weight: 500;
                font-size: 14px;
            }
            .for_heading{
                font-weight: 500;
                font-size: 14px;
            }
    
            .signature_div{
                height: 20%;
                border-bottom: 1px solid black;
            }
            .disclaimer{
                border: 1px solid black;
                text-align: right;
                font-size: 14px;
                width: 95%;
                padding-right: 4px;
            }
            p{
                font-size: 14px;
            }
        </style>
    </head>
    <body>
        <div class="container">
            <div class="header">
                <p>GSTIN: <b>${companyDetails?.gst || ""}</b> </p>
                <p style="margin: auto;">${copyType}</p>
            </div>
            <hr>
            <div class="stamp">
                <p class="para">${invoice?.billType?.toUpperCase() || ""}</p>
                <p class="company_name para">${
                  companyDetails?.businessName || ""
                }</p>
                <p class="address">${companyDetails?.address || ""}</p>
                <p class="address">Mobile Number : ${
                  companyDetails?.phoneNumber || ""
                }</p>
                <p class="address">Email: ${companyDetails?.email || ""}</p>
            </div>
            <hr>
            <div class="box-parent">
                <div class="box-div pdf-flex">
                    <div class="list">
                        <p>Invoice No :</p>
                        <p>Date of Invoice :</p>
                        <p>State of Supply :</p>
                    </div>
                    <div class="list">
                        <p>${invoiceNumber || ""}</p>
                        <p>${getFormattedBillingDate(invoiceDate)}</p>
                        <p>${stateOfSupply || ""}</p>
                    </div>
                </div>
                <div class="box-div pdf-flex">
                    <div class="list">
                        <p>Transport :</p>
                        <p>Vehicle :</p>
                        <p>Station :</p>
                        <p>E-Way Bill No :</p>
                    </div>
                    <div class="list">
                        <p>${transport || ""}</p>
                        <p>${vehicle || ""}</p>
                        <p>${station || ""}</p>
                        <p>${eWayBillNo || ""}</p>
                    </div>
                </div>
            </div>
            <div class="box-parent">
                <div class="box-div">
                    <div class="list">
                        <i>Billed to :</i>
                        <p>${name || ""}</p>
                        <p>${address || ""}</p>
                        <p>Mob : ${phoneNumber || ""}</p>
                        <p>GSTIN / UIN : ${gst || ""}</p>
                    </div>
                </div>
                <div class="box-div">
                    <div class="list">
                        <i>Shipped to :</i>
                        <p>${name}</p>
                        <p>${address}</p>
                        <p>Mob : ${phoneNumber}</p>
                        <p>GSTIN / UIN : ${gst}</p>
                    </div>
                </div>
            </div>
            <div class="table_container">
                <table>
                    <thead>
                        <tr>
                            <td>S.No</td>
                            <td>Particulars</td>
                            <td>HSN Code</td>
                            <td style="width: 10px;">Warranty (in months)</td>
                            <td>Qty.</td>
                            <td>Rate</td>
                            <td>Amount</td>
                            <td colspan="2">SGST Amount</td>
                            <td colspan="2">GGST Amount</td>
                            <td colspan="2">IGST Amount</td>
                            <td>Grand Total</td>
                        </tr>
                    </thead>
                    <tbody>
                        ${
                          items
                            ?.map(
                              (item, index) => `
                            <tr>
                                <td>${index + 1}</td>
                                <td>${item.name}</td>
                                <td>${item.hsnCode}</td>
                                <td>${item.warranty || 0}</td>
                                <td>${+item.quantity || 0}</td>
                                <td>${
                                  parseFloat(item.price).toFixed(2) || 0
                                }</td>
                                <td>${
                                  +item.amountBeforeTax.toFixed(2) || 0
                                }</td>
                                <td>${+item.sgst || 0}</td>
                                <td>${+item.sgstAmount.toFixed(2)}</td>
                                <td>${+item.cgst || 0}</td>
                                <td>${+item.cgstAmount.toFixed(2) || 0}</td>
                                <td>${+item.igst || 0}</td>
                                <td>${+item.igstAmount.toFixed(2) || 0}</td>
                                <td>${+item.grandTotal.toFixed(2) || 0}</td>
                            </tr>
                        `
                            )
                            .join("") || ""
                        }
                        <tr>
                            <td colspan="6">Total</td>
                            <td>${totalAmountBeforeTax.toFixed(2)}</td>
                            <td colspan="2">${totalSgstAmount.toFixed(2)}</td>
                            <td colspan="2">${totalCgstAmount.toFixed(2)}</td>
                            <td colspan="2">${totalIgstAmount.toFixed(2)}</td>
                            <td>${totalGrandTotal.toFixed(2)}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="table_container" id="2">
                <table>
                    <thead>
                        <tr>
                            <td>HSN/SAC</td>
                            <td>Tax Rate</td>
                            <td>Taxable Amount</td>
                            <td style="width: 10px;">CGST Amount</td>
                            <td style="width: 10px;">IGST Amount</td>
                            <td style="width: 10px;">SGST Amount</td>
                            <td>Total tax</td>
                        </tr>
                    </thead>
                    <tbody>
                    ${
                      groupedItems
                        ?.map(
                          (item, index) => `
                    <tr key=${index}>
                        <td>${item.hsnCode}</td>
<td>${(
                            Number(item?.sgst ?? 0) +
                            Number(item?.cgst ?? 0) +
                            Number(item?.igst ?? 0)
                          ).toFixed(2)}</td>
                        <td>${item.amountBeforeTax.toFixed(2)}</td>
                        <td>${item.cgstAmount.toFixed(2)}</td>
                        <td>${item.igstAmount.toFixed(2) || 0}</td>
                        <td>${item.sgstAmount.toFixed(2)}</td>
                        <td>${(
                          item.cgstAmount +
                          item.sgstAmount +
                          Number(item.igstAmount ?? 0)
                        ).toFixed(2)}</td>
                    </tr>
                `
                        )
                        .join("") || ""
                    }
                        <tr>
                            <td>Totals</td>
                            <td></td>
                            <td>${totalAmountBeforeTax.toFixed(2)}</td>
                            <td>${totalCgstAmount.toFixed(2)}</td>
                            <td>${totalIgstAmount.toFixed(2)}</td>
                            <td>${totalSgstAmount.toFixed(2)}</td>
                            <td>${totalGrandTotal.toFixed(2)}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <h5>${converter.convert(totalGrandTotal)}</h5>
            <div class="bank_container">
                <p>Bank Name : ${companyDetails?.bankName}</p>
                <p>IFSC Code : ${companyDetails?.ifscCode}</p>
                <p>Account Number : ${companyDetails?.bankAccountNumber}</p>
                <p>Branch : ${companyDetails?.bankBranch}</p>
            </div>
            <div class="pdf-footer">
                <div class="terms">
                    <h5 class="terms_heading">Terms & Conditions</h5>
                    <p>E. & E.O.</p>
                    <p>1) Goods once sold will not be taken back</p>
                    <p>2) Interest @18% p.a. will be charged if the payment is not made within the stipulated time.</p>
                    <p>3) Subject to '${
                      companyDetails?.jurisdiction
                    }' Jurisdiction only.</p>
                </div>
                <div class="terms">
                    <div class="signature_div">
                        <h5 class="terms_heading">Receiver's Signature</h5>
                        <p></p>
                        <p></p>
                        <p></p>
                        <p></p>
                    </div>
                    <div class="">
                        <h5 class="for_heading">for ${
                          companyDetails?.businessName
                        }</h5>
                        <div style="height: 60px;"></div>
                        <p class="for_heading">Authorised Signatory</p>
                    </div>
                </div>
            </div>
            <div class="pdf-footer">
                <p>**this is computer generated invoice no signature required**</p>
            </div>
        </div>
    </body>
    </html>`;
};
export const minimalistModernTemplate = (invoice, copyType) => {
  if (!invoice) return;

  const {
    companyDetails,
    invoiceNumber,
    invoiceDate,
    stateOfSupply,
    eWayBillNo = "",
    customerDetails,
    items,
    transport,
    vehicle,
    station,
    isPreview = false,
  } = invoice;

  const {
    address = "",
    phoneNumber = "",
    gst = "",
    name = "",
  } = customerDetails ?? {};

  let totalAmountBeforeTax = 0;
  let totalSgstAmount = 0;
  let totalCgstAmount = 0;
  let totalIgstAmount = 0;
  let totalGrandTotal = 0;

  items?.forEach((item) => {
    item.amountBeforeTax = +item.quantity * +item.price;
    item.sgstAmount = +item.amountBeforeTax * (item.sgst / 100);
    item.cgstAmount = +item.amountBeforeTax * (item.cgst / 100);
    item.igstAmount = +item.amountBeforeTax * (item.igst / 100) || 0;
    item.grandTotal =
      +item.amountBeforeTax * (+item.cgst / 100) +
      +item.amountBeforeTax * (+item.sgst / 100) +
      (+item.amountBeforeTax * (+item.igst / 100) || 0) +
      +item.amountBeforeTax;
    totalAmountBeforeTax += +item.amountBeforeTax;
    totalSgstAmount += +item.sgstAmount;
    totalCgstAmount += +item.cgstAmount;
    totalIgstAmount += +item.igstAmount || 0;
    totalGrandTotal += +item.grandTotal;
  });

  const groupedItems = groupItemsByHsnCode(items);

  const nonPreviewStyles = isPreview
    ? ""
    : `
    html, body {
      margin: 0;
      padding: 0;
    }
    body {
      font-family: 'Inter', sans-serif;
      padding: 0px;
      background: #f9fafb;
    }
  `;

  return `<!DOCTYPE html>
    <html lang="en">
    <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>${name}</title>
        <style>
        ${nonPreviewStyles}
        
        .container {
            max-width: 800px;
            margin: 20px auto;
            background: white;
            border-radius: 12px;
            overflow: hidden;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
            font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
        }
        
        .header {
            background: linear-gradient(135deg, #1e40af 0%, #3b82f6 100%);
            color: white;
            padding: 30px;
            position: relative;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        
        .header::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            height: 4px;
            background: linear-gradient(90deg, #06b6d4, #0891b2, #0e7490);
        }
        
        .header p {
            margin: 0;
            font-size: 14px;
            opacity: 0.9;
        }
        
        .copy-type {
            background: rgba(255, 255, 255, 0.2);
            backdrop-filter: blur(10px);
            padding: 8px 16px;
            border-radius: 20px;
            font-size: 12px;
            font-weight: 600;
        }
        
        .content {
            padding: 30px;
        }
        
        .company-section {
            text-align: center;
            margin-bottom: 30px;
            padding: 24px;
            background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
            border-radius: 8px;
            border-left: 4px solid #0891b2;
        }
        
        .bill-type {
            font-size: 16px;
            font-weight: 600;
            color: #374151;
            margin-bottom: 8px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
        }
        
        .company-name {
            font-size: 28px;
            font-weight: 800;
            color: #1e40af;
            margin-bottom: 12px;
            letter-spacing: -0.5px;
        }
        
        .company-details {
            font-size: 14px;
            color: #6b7280;
            margin-bottom: 4px;
        }
        
        .info-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 30px;
            margin-bottom: 30px;
        }
        
        .info-card {
            background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
            border-radius: 8px;
            padding: 24px;
            border-left: 4px solid #0891b2;
        }
        
        .info-row {
            display: flex;
            justify-content: space-between;
            margin-bottom: 12px;
            font-size: 14px;
        }
        
        .info-label {
            color: #6b7280;
            font-weight: 500;
        }
        
        .info-value {
            color: #1f2937;
            font-weight: 600;
        }
        
        .customer-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 30px;
            margin-bottom: 30px;
        }
        
        .customer-card {
            background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
            border-radius: 8px;
            padding: 24px;
            border: 1px solid #bfdbfe;
        }
        
        .customer-title {
            font-style: italic;
            font-weight: 700;
            color: #1e40af;
            margin-bottom: 16px;
            font-size: 14px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
        }
        
        .customer-detail {
            margin-bottom: 8px;
            font-size: 14px;
            color: #1f2937;
        }
        
        .items-table {
            width: 100%;
            border-collapse: collapse;
            margin-bottom: 20px;
            background: white;
            border-radius: 8px;
            overflow: hidden;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        }
        
        .items-table th {
            background: linear-gradient(135deg, #1e40af 0%, #3b82f6 100%);
            color: white;
            padding: 16px 8px;
            text-align: center;
            font-weight: 600;
            font-size: 12px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
        }
        
        .items-table td {
            padding: 16px 8px;
            text-align: center;
            border-bottom: 1px solid #f1f5f9;
            font-size: 12px;
        }
        
        .items-table tr:hover {
            background: #f8fafc;
        }
        
        .items-table tr:last-child td {
            border-bottom: none;
            font-weight: 700;
            background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
            color: #1e40af;
        }
        
        .amount-words {
            background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
            border: 1px solid #bfdbfe;
            border-radius: 8px;
            padding: 20px;
            margin-bottom: 20px;
            font-weight: 600;
            color: #1e40af;
        }
        
        .bank-details {
            background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
            padding: 20px;
            border-radius: 8px;
            margin-bottom: 20px;
            border-left: 4px solid #0891b2;
        }
        
        .bank-details p {
            margin: 6px 0;
            font-size: 14px;
            color: #374151;
        }
        
        .footer-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 30px;
            margin-top: 30px;
            padding-top: 30px;
            border-top: 2px solid #f1f5f9;
        }
        
        .terms-card, .signature-card {
            background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
            border-radius: 8px;
            padding: 24px;
            border-left: 4px solid #0891b2;
        }
        
        .section-title {
            font-weight: 700;
            font-size: 14px;
            color: #1f2937;
            margin-bottom: 16px;
            text-decoration: underline;
            text-transform: uppercase;
            letter-spacing: 0.5px;
        }
        
        .terms-card p {
            margin: 8px 0;
            font-size: 13px;
            color: #6b7280;
        }
        
        .signature-area {
            height: 60px;
            border: 2px dashed #d1d5db;
            border-radius: 4px;
            margin-bottom: 16px;
            background: rgba(255, 255, 255, 0.5);
        }
        
        .signature-label {
            font-weight: 600;
            font-size: 14px;
            color: #374151;
        }
        
        .disclaimer {
            text-align: center;
            font-size: 12px;
            color: #6b7280;
            margin-top: 20px;
            font-style: italic;
        }
        </style>
    </head>
    <body>
        <div class="container">
            <div class="header">
                <p>GSTIN: <strong>${companyDetails?.gst || ""}</strong></p>
                <div class="copy-type">${copyType}</div>
            </div>
            
            <div class="content">
                <div class="company-section">
                    <div class="bill-type">${
                      invoice?.billType?.toUpperCase() || ""
                    }</div>
                    <div class="company-name">${
                      companyDetails?.businessName || ""
                    }</div>
                    <div class="company-details">${
                      companyDetails?.address || ""
                    }</div>
                    <div class="company-details">Mobile: ${
                      companyDetails?.phoneNumber || ""
                    }</div>
                    <div class="company-details">Email: ${
                      companyDetails?.email || ""
                    }</div>
                </div>
                
                <div class="info-grid">
                    <div class="info-card">
                        <div class="info-row">
                            <span class="info-label">Invoice No:</span>
                            <span class="info-value">${
                              invoiceNumber || ""
                            }</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">Date of Invoice:</span>
                            <span class="info-value">${getFormattedBillingDate(
                              invoiceDate
                            )}</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">State of Supply:</span>
                            <span class="info-value">${
                              stateOfSupply || ""
                            }</span>
                        </div>
                    </div>
                    <div class="info-card">
                        <div class="info-row">
                            <span class="info-label">Transport:</span>
                            <span class="info-value">${transport || ""}</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">Vehicle:</span>
                            <span class="info-value">${vehicle || ""}</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">Station:</span>
                            <span class="info-value">${station || ""}</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">E-Way Bill No:</span>
                            <span class="info-value">${eWayBillNo || ""}</span>
                        </div>
                    </div>
                </div>
                
                <div class="customer-grid">
                    <div class="customer-card">
                        <div class="customer-title">Billed to:</div>
                        <div class="customer-detail">${name || ""}</div>
                        <div class="customer-detail">${address || ""}</div>
                        <div class="customer-detail">Mob: ${
                          phoneNumber || ""
                        }</div>
                        <div class="customer-detail">GSTIN/UIN: ${
                          gst || ""
                        }</div>
                    </div>
                    <div class="customer-card">
                        <div class="customer-title">Shipped to:</div>
                        <div class="customer-detail">${name}</div>
                        <div class="customer-detail">${address}</div>
                        <div class="customer-detail">Mob: ${phoneNumber}</div>
                        <div class="customer-detail">GSTIN/UIN: ${gst}</div>
                    </div>
                </div>
                
                <table class="items-table">
                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th>Particulars</th>
                            <th>HSN Code</th>
                            <th>Warranty (months)</th>
                            <th>Qty.</th>
                            <th>Rate</th>
                            <th>Amount</th>
                            <th colspan="2">SGST Amount</th>
                            <th colspan="2">CGST Amount</th>
                            <th colspan="2">IGST Amount</th>
                            <th>Grand Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${
                          items
                            ?.map(
                              (item, index) => `
                            <tr>
                                <td>${index + 1}</td>
                                <td>${item.name}</td>
                                <td>${item.hsnCode}</td>
                                <td>${item.warranty || 0}</td>
                                <td>${+item.quantity || 0}</td>
                                <td>${
                                  Number.parseFloat(item.price).toFixed(2) || 0
                                }</td>
                                <td>${
                                  +item.amountBeforeTax.toFixed(2) || 0
                                }</td>
                                <td>${+item.sgst || 0}</td>
                                <td>${+item.sgstAmount.toFixed(2)}</td>
                                <td>${+item.cgst || 0}</td>
                                <td>${+item.cgstAmount.toFixed(2) || 0}</td>
                                <td>${+item.igst || 0}</td>
                                <td>${+item.igstAmount.toFixed(2) || 0}</td>
                                <td>${+item.grandTotal.toFixed(2) || 0}</td>
                            </tr>
                        `
                            )
                            .join("") || ""
                        }
                        <tr>
                            <td colspan="6">Total</td>
                            <td>${totalAmountBeforeTax.toFixed(2)}</td>
                            <td colspan="2">${totalSgstAmount.toFixed(2)}</td>
                            <td colspan="2">${totalCgstAmount.toFixed(2)}</td>
                            <td colspan="2">${totalIgstAmount.toFixed(2)}</td>
                            <td>${totalGrandTotal.toFixed(2)}</td>
                        </tr>
                    </tbody>
                </table>
                
                <table class="items-table">
                    <thead>
                        <tr>
                            <th>HSN/SAC</th>
                            <th>Tax Rate</th>
                            <th>Taxable Amount</th>
                            <th>CGST Amount</th>
                            <th>IGST Amount</th>
                            <th>SGST Amount</th>
                            <th>Total tax</th>
                        </tr>
                    </thead>
                    <tbody>
                    ${
                      groupedItems
                        ?.map(
                          (item, index) => `
                        <tr key=${index}>
                            <td>${item.hsnCode}</td>
                            <td>${(
                              Number(item?.sgst ?? 0) +
                              Number(item?.cgst ?? 0) +
                              Number(item?.igst ?? 0)
                            ).toFixed(2)}</td>
                            <td>${item.amountBeforeTax.toFixed(2)}</td>
                            <td>${item.cgstAmount.toFixed(2)}</td>
                            <td>${item.igstAmount.toFixed(2) || 0}</td>
                            <td>${item.sgstAmount.toFixed(2)}</td>
                            <td>${(
                              item.cgstAmount +
                              item.sgstAmount +
                              Number(item.igstAmount ?? 0)
                            ).toFixed(2)}</td>
                        </tr>
                    `
                        )
                        .join("") || ""
                    }
                        <tr>
                            <td>Totals</td>
                            <td></td>
                            <td>${totalAmountBeforeTax.toFixed(2)}</td>
                            <td>${totalCgstAmount.toFixed(2)}</td>
                            <td>${totalIgstAmount.toFixed(2)}</td>
                            <td>${totalSgstAmount.toFixed(2)}</td>
                            <td>${totalGrandTotal.toFixed(2)}</td>
                        </tr>
                    </tbody>
                </table>
                
                <div class="amount-words">${converter.convert(
                  totalGrandTotal
                )}</div>
                
                <div class="bank-details">
                    <p><strong>Bank Name:</strong> ${
                      companyDetails?.bankName
                    }</p>
                    <p><strong>IFSC Code:</strong> ${
                      companyDetails?.ifscCode
                    }</p>
                    <p><strong>Account Number:</strong> ${
                      companyDetails?.bankAccountNumber
                    }</p>
                    <p><strong>Branch:</strong> ${
                      companyDetails?.bankBranch
                    }</p>
                </div>
                
                <div class="footer-grid">
                    <div class="terms-card">
                        <div class="section-title">Terms & Conditions</div>
                        <p>E. & E.O.</p>
                        <p>1) Goods once sold will not be taken back</p>
                        <p>2) Interest @18% p.a. will be charged if the payment is not made within the stipulated time.</p>
                        <p>3) Subject to '${
                          companyDetails?.jurisdiction
                        }' Jurisdiction only.</p>
                    </div>
                    <div class="signature-card">
                        <div class="section-title">Receiver's Signature</div>
                        <div class="signature-area"></div>
                        <div class="signature-label">for ${
                          companyDetails?.businessName
                        }</div>
                        <div style="height: 40px;"></div>
                        <div class="signature-label">Authorised Signatory</div>
                    </div>
                </div>
                
                <div class="disclaimer">**this is computer generated invoice no signature required**</div>
            </div>
        </div>
    </body>
    </html>`;
};
export const minimalistCleanTemplate = (invoice, copyType) => {
  if (!invoice) return;

  const {
    companyDetails,
    invoiceNumber,
    invoiceDate,
    stateOfSupply,
    eWayBillNo = "",
    customerDetails,
    items,
    transport,
    vehicle,
    station,
    isPreview = false,
  } = invoice;

  const {
    address = "",
    phoneNumber = "",
    gst = "",
    name = "",
  } = customerDetails ?? {};

  let totalAmountBeforeTax = 0;
  let totalSgstAmount = 0;
  let totalCgstAmount = 0;
  let totalIgstAmount = 0;
  let totalGrandTotal = 0;

  items?.forEach((item) => {
    item.amountBeforeTax = +item.quantity * +item.price;
    item.sgstAmount = +item.amountBeforeTax * (item.sgst / 100);
    item.cgstAmount = +item.amountBeforeTax * (item.cgst / 100);
    item.igstAmount = +item.amountBeforeTax * (item.igst / 100) || 0;
    item.grandTotal =
      +item.amountBeforeTax * (+item.cgst / 100) +
      +item.amountBeforeTax * (+item.sgst / 100) +
      (+item.amountBeforeTax * (+item.igst / 100) || 0) +
      +item.amountBeforeTax;
    totalAmountBeforeTax += +item.amountBeforeTax;
    totalSgstAmount += +item.sgstAmount;
    totalCgstAmount += +item.cgstAmount;
    totalIgstAmount += +item.igstAmount || 0;
    totalGrandTotal += +item.grandTotal;
  });

  const groupedItems = groupItemsByHsnCode(items);

  const nonPreviewStyles = isPreview
    ? ""
    : `
    html, body {
      margin: 0;
      padding: 0;
    }
    body {
      font-family: 'Inter', sans-serif;
      padding: 0px;
    }
  `;

  return `<!DOCTYPE html>
    <html lang="en">
    <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>${name}</title>
        <style>
        ${nonPreviewStyles}
        
        .container {
            max-width: 800px;
            margin: 0 auto;
            padding: 20px;
            background: #ffffff;
            font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
            line-height: 1.6;
            color: #1f2937;
        }
        
        .header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 30px;
            padding-bottom: 20px;
            border-bottom: 2px solid #06b6d4;
        }
        
        .header p {
            margin: 0;
            font-size: 14px;
            color: #6b7280;
        }
        
        .copy-type {
            background: #06b6d4;
            color: white;
            padding: 6px 16px;
            border-radius: 6px;
            font-size: 12px;
            font-weight: 600;
        }
        
        .company-section {
            text-align: center;
            margin-bottom: 30px;
            padding: 20px;
            background: #f8fafc;
            border-radius: 8px;
            border-left: 4px solid #06b6d4;
        }
        
        .bill-type {
            font-size: 16px;
            font-weight: 600;
            color: #374151;
            margin-bottom: 8px;
        }
        
        .company-name {
            font-size: 24px;
            font-weight: 700;
            color: #06b6d4;
            margin-bottom: 12px;
        }
        
        .company-details {
            font-size: 14px;
            color: #6b7280;
            margin-bottom: 4px;
        }
        
        .info-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 30px;
            margin-bottom: 30px;
        }
        
        .info-box {
            background: white;
            border: 1px solid #e5e7eb;
            border-radius: 8px;
            padding: 20px;
        }
        
        .info-row {
            display: flex;
            justify-content: space-between;
            margin-bottom: 8px;
            font-size: 14px;
        }
        
        .info-label {
            color: #6b7280;
            font-weight: 500;
        }
        
        .info-value {
            color: #1f2937;
            font-weight: 600;
        }
        
        .customer-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 30px;
            margin-bottom: 30px;
        }
        
        .customer-box {
            background: #f8fafc;
            border: 1px solid #e5e7eb;
            border-radius: 8px;
            padding: 20px;
        }
        
        .customer-title {
            font-style: italic;
            font-weight: 600;
            color: #374151;
            margin-bottom: 12px;
            font-size: 14px;
        }
        
        .customer-detail {
            margin-bottom: 6px;
            font-size: 14px;
            color: #1f2937;
        }
        
        .items-table {
            width: 100%;
            border-collapse: collapse;
            margin-bottom: 20px;
            background: white;
            border-radius: 8px;
            overflow: hidden;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        }
        
        .items-table th {
            background: linear-gradient(135deg, #06b6d4, #0891b2);
            color: white;
            padding: 12px 8px;
            text-align: center;
            font-weight: 600;
            font-size: 12px;
        }
        
        .items-table td {
            padding: 12px 8px;
            text-align: center;
            border-bottom: 1px solid #f3f4f6;
            font-size: 12px;
        }
        
        .items-table tr:nth-child(even) {
            background: #f8fafc;
        }
        
        .items-table tr:last-child td {
            border-bottom: none;
            font-weight: 600;
            background: #e0f2fe;
        }
        
        .amount-words {
            background: #f0f9ff;
            border: 1px solid #0891b2;
            border-radius: 6px;
            padding: 12px;
            margin-bottom: 20px;
            font-weight: 600;
            color: #0c4a6e;
        }
        
        .bank-details {
            background: #f8fafc;
            padding: 16px;
            border-radius: 8px;
            margin-bottom: 20px;
            border-left: 4px solid #06b6d4;
        }
        
        .bank-details p {
            margin: 4px 0;
            font-size: 14px;
            color: #374151;
        }
        
        .footer-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 20px;
            margin-top: 20px;
        }
        
        .terms-box, .signature-box {
            border: 1px solid #e5e7eb;
            border-radius: 8px;
            padding: 16px;
            background: white;
        }
        
        .section-title {
            font-weight: 600;
            font-size: 14px;
            color: #374151;
            margin-bottom: 12px;
            text-decoration: underline;
        }
        
        .terms-box p {
            margin: 6px 0;
            font-size: 13px;
            color: #6b7280;
        }
        
        .signature-area {
            height: 60px;
            border-bottom: 1px solid #e5e7eb;
            margin-bottom: 12px;
        }
        
        .signature-label {
            font-weight: 600;
            font-size: 14px;
            color: #374151;
        }
        
        .disclaimer {
            text-align: center;
            font-size: 12px;
            color: #6b7280;
            margin-top: 20px;
            font-style: italic;
        }
        </style>
    </head>
    <body>
        <div class="container">
            <div class="header">
                <p>GSTIN: <strong>${companyDetails?.gst || ""}</strong></p>
                <div class="copy-type">${copyType}</div>
            </div>
            
            <div class="company-section">
                <div class="bill-type">${
                  invoice?.billType?.toUpperCase() || ""
                }</div>
                <div class="company-name">${
                  companyDetails?.businessName || ""
                }</div>
                <div class="company-details">${
                  companyDetails?.address || ""
                }</div>
                <div class="company-details">Mobile: ${
                  companyDetails?.phoneNumber || ""
                }</div>
                <div class="company-details">Email: ${
                  companyDetails?.email || ""
                }</div>
            </div>
            
            <div class="info-grid">
                <div class="info-box">
                    <div class="info-row">
                        <span class="info-label">Invoice No:</span>
                        <span class="info-value">${invoiceNumber || ""}</span>
                    </div>
                    <div class="info-row">
                        <span class="info-label">Date of Invoice:</span>
                        <span class="info-value">${getFormattedBillingDate(
                          invoiceDate
                        )}</span>
                    </div>
                    <div class="info-row">
                        <span class="info-label">State of Supply:</span>
                        <span class="info-value">${stateOfSupply || ""}</span>
                    </div>
                </div>
                <div class="info-box">
                    <div class="info-row">
                        <span class="info-label">Transport:</span>
                        <span class="info-value">${transport || ""}</span>
                    </div>
                    <div class="info-row">
                        <span class="info-label">Vehicle:</span>
                        <span class="info-value">${vehicle || ""}</span>
                    </div>
                    <div class="info-row">
                        <span class="info-label">Station:</span>
                        <span class="info-value">${station || ""}</span>
                    </div>
                    <div class="info-row">
                        <span class="info-label">E-Way Bill No:</span>
                        <span class="info-value">${eWayBillNo || ""}</span>
                    </div>
                </div>
            </div>
            
            <div class="customer-grid">
                <div class="customer-box">
                    <div class="customer-title">Billed to:</div>
                    <div class="customer-detail">${name || ""}</div>
                    <div class="customer-detail">${address || ""}</div>
                    <div class="customer-detail">Mob: ${phoneNumber || ""}</div>
                    <div class="customer-detail">GSTIN/UIN: ${gst || ""}</div>
                </div>
                <div class="customer-box">
                    <div class="customer-title">Shipped to:</div>
                    <div class="customer-detail">${name}</div>
                    <div class="customer-detail">${address}</div>
                    <div class="customer-detail">Mob: ${phoneNumber}</div>
                    <div class="customer-detail">GSTIN/UIN: ${gst}</div>
                </div>
            </div>
            
            <table class="items-table">
                <thead>
                    <tr>
                        <th>S.No</th>
                        <th>Particulars</th>
                        <th>HSN Code</th>
                        <th>Warranty (months)</th>
                        <th>Qty.</th>
                        <th>Rate</th>
                        <th>Amount</th>
                        <th colspan="2">SGST Amount</th>
                        <th colspan="2">CGST Amount</th>
                        <th colspan="2">IGST Amount</th>
                        <th>Grand Total</th>
                    </tr>
                </thead>
                <tbody>
                    ${
                      items
                        ?.map(
                          (item, index) => `
                        <tr>
                            <td>${index + 1}</td>
                            <td>${item.name}</td>
                            <td>${item.hsnCode}</td>
                            <td>${item.warranty || 0}</td>
                            <td>${+item.quantity || 0}</td>
                            <td>${
                              Number.parseFloat(item.price).toFixed(2) || 0
                            }</td>
                            <td>${+item.amountBeforeTax.toFixed(2) || 0}</td>
                            <td>${+item.sgst || 0}</td>
                            <td>${+item.sgstAmount.toFixed(2)}</td>
                            <td>${+item.cgst || 0}</td>
                            <td>${+item.cgstAmount.toFixed(2) || 0}</td>
                            <td>${+item.igst || 0}</td>
                            <td>${+item.igstAmount.toFixed(2) || 0}</td>
                            <td>${+item.grandTotal.toFixed(2) || 0}</td>
                        </tr>
                    `
                        )
                        .join("") || ""
                    }
                    <tr>
                        <td colspan="6">Total</td>
                        <td>${totalAmountBeforeTax.toFixed(2)}</td>
                        <td colspan="2">${totalSgstAmount.toFixed(2)}</td>
                        <td colspan="2">${totalCgstAmount.toFixed(2)}</td>
                        <td colspan="2">${totalIgstAmount.toFixed(2)}</td>
                        <td>${totalGrandTotal.toFixed(2)}</td>
                    </tr>
                </tbody>
            </table>
            
            <table class="items-table">
                <thead>
                    <tr>
                        <th>HSN/SAC</th>
                        <th>Tax Rate</th>
                        <th>Taxable Amount</th>
                        <th>CGST Amount</th>
                        <th>IGST Amount</th>
                        <th>SGST Amount</th>
                        <th>Total tax</th>
                    </tr>
                </thead>
                <tbody>
                ${
                  groupedItems
                    ?.map(
                      (item, index) => `
                    <tr key=${index}>
                        <td>${item.hsnCode}</td>
                        <td>${(
                          Number(item?.sgst ?? 0) +
                          Number(item?.cgst ?? 0) +
                          Number(item?.igst ?? 0)
                        ).toFixed(2)}</td>
                        <td>${item.amountBeforeTax.toFixed(2)}</td>
                        <td>${item.cgstAmount.toFixed(2)}</td>
                        <td>${item.igstAmount.toFixed(2) || 0}</td>
                        <td>${item.sgstAmount.toFixed(2)}</td>
                        <td>${(
                          item.cgstAmount +
                          item.sgstAmount +
                          Number(item.igstAmount ?? 0)
                        ).toFixed(2)}</td>
                    </tr>
                `
                    )
                    .join("") || ""
                }
                    <tr>
                        <td>Totals</td>
                        <td></td>
                        <td>${totalAmountBeforeTax.toFixed(2)}</td>
                        <td>${totalCgstAmount.toFixed(2)}</td>
                        <td>${totalIgstAmount.toFixed(2)}</td>
                        <td>${totalSgstAmount.toFixed(2)}</td>
                        <td>${totalGrandTotal.toFixed(2)}</td>
                    </tr>
                </tbody>
            </table>
            
            <div class="amount-words">${converter.convert(
              totalGrandTotal
            )}</div>
            
            <div class="bank-details">
                <p><strong>Bank Name:</strong> ${companyDetails?.bankName}</p>
                <p><strong>IFSC Code:</strong> ${companyDetails?.ifscCode}</p>
                <p><strong>Account Number:</strong> ${
                  companyDetails?.bankAccountNumber
                }</p>
                <p><strong>Branch:</strong> ${companyDetails?.bankBranch}</p>
            </div>
            
            <div class="footer-grid">
                <div class="terms-box">
                    <div class="section-title">Terms & Conditions</div>
                    <p>E. & E.O.</p>
                    <p>1) Goods once sold will not be taken back</p>
                    <p>2) Interest @18% p.a. will be charged if the payment is not made within the stipulated time.</p>
                    <p>3) Subject to '${
                      companyDetails?.jurisdiction
                    }' Jurisdiction only.</p>
                </div>
                <div class="signature-box">
                    <div class="section-title">Receiver's Signature</div>
                    <div class="signature-area"></div>
                    <div class="signature-label">for ${
                      companyDetails?.businessName
                    }</div>
                    <div style="height: 40px;"></div>
                    <div class="signature-label">Authorised Signatory</div>
                </div>
            </div>
            
            <div class="disclaimer">**this is computer generated invoice no signature required**</div>
        </div>
    </body>
    </html>`;
};

export const colorfulVibrantTemplate = (invoice, copyType) => {
  if (!invoice) return;

  const {
    companyDetails,
    invoiceNumber,
    invoiceDate,
    stateOfSupply,
    eWayBillNo = "",
    customerDetails,
    items,
    transport,
    vehicle,
    station,
    isPreview = false,
  } = invoice;

  const {
    address = "",
    phoneNumber = "",
    gst = "",
    name = "",
  } = customerDetails ?? {};

  let totalAmountBeforeTax = 0;
  let totalSgstAmount = 0;
  let totalCgstAmount = 0;
  let totalIgstAmount = 0;
  let totalGrandTotal = 0;

  items?.forEach((item) => {
    item.amountBeforeTax = +item.quantity * +item.price;
    item.sgstAmount = +item.amountBeforeTax * (item.sgst / 100);
    item.cgstAmount = +item.amountBeforeTax * (item.cgst / 100);
    item.igstAmount = +item.amountBeforeTax * (item.igst / 100) || 0;
    item.grandTotal =
      +item.amountBeforeTax * (+item.cgst / 100) +
      +item.amountBeforeTax * (+item.sgst / 100) +
      (+item.amountBeforeTax * (+item.igst / 100) || 0) +
      +item.amountBeforeTax;
    totalAmountBeforeTax += +item.amountBeforeTax;
    totalSgstAmount += +item.sgstAmount;
    totalCgstAmount += +item.cgstAmount;
    totalIgstAmount += +item.igstAmount || 0;
    totalGrandTotal += +item.grandTotal;
  });

  const groupedItems = groupItemsByHsnCode(items);

  const nonPreviewStyles = isPreview
    ? ""
    : `
    html, body {
      margin: 0;
      padding: 0;
    }
    body {
      font-family: 'Inter', sans-serif;
      padding: 0px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%);
      min-height: 100vh;
    }
  `;

  return `<!DOCTYPE html>
    <html lang="en">
    <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>${name}</title>
        <style>
        ${nonPreviewStyles}
        
        .container {
            max-width: 850px;
            margin: 20px auto;
            background: white;
            border-radius: 20px;
            overflow: hidden;
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
            font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
        }
        
        .header {
            background: linear-gradient(135deg, #ff416c 0%, #ff4b2b 50%, #ff6b35 100%);
            color: white;
            padding: 40px;
            position: relative;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        
        .header-pattern {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-image: 
                radial-gradient(circle at 25% 25%, rgba(255,255,255,0.1) 2px, transparent 2px),
                radial-gradient(circle at 75% 75%, rgba(255,255,255,0.1) 2px, transparent 2px);
            background-size: 50px 50px;
        }
        
        .header p {
            margin: 0;
            font-size: 14px;
            opacity: 0.9;
            position: relative;
            z-index: 2;
        }
        
        .copy-type {
            background: linear-gradient(45deg, #4ecdc4, #44a08d);
            padding: 8px 20px;
            border-radius: 25px;
            font-size: 12px;
            font-weight: 700;
            text-transform: uppercase;
            letter-spacing: 1px;
            box-shadow: 0 4px 15px rgba(78, 205, 196, 0.4);
            position: relative;
            z-index: 2;
        }
        
        .content {
            padding: 40px;
        }
        
        .company-section {
            text-align: center;
            margin-bottom: 40px;
            padding: 40px;
            background: linear-gradient(135deg, #a8edea 0%, #fed6e3 100%);
            border-radius: 15px;
            border-left: 8px solid #ff416c;
        }
        
        .bill-type {
            font-size: 16px;
            font-weight: 600;
            color: #2d3748;
            margin-bottom: 12px;
            text-transform: uppercase;
            letter-spacing: 2px;
        }
        
        .company-name {
            font-size: 38px;
            font-weight: 900;
            color: #ff416c;
            margin-bottom: 12px;
            letter-spacing: -1px;
            text-shadow: 0 4px 8px rgba(255, 65, 108, 0.3);
        }
        
        .company-details {
            font-size: 14px;
            color: #4a5568;
            margin-bottom: 4px;
            line-height: 1.8;
        }
        
        .info-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 40px;
            margin-bottom: 40px;
        }
        
        .info-card {
            background: white;
            padding: 30px;
            border-radius: 15px;
            box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
            border-top: 6px solid #4ecdc4;
            position: relative;
            overflow: hidden;
        }
        
        .info-card:nth-child(2) {
            border-top-color: #ffeaa7;
        }
        
        .info-card::before {
            content: '';
            position: absolute;
            top: -50%;
            right: -50%;
            width: 100px;
            height: 100px;
            background: radial-gradient(circle, rgba(78, 205, 196, 0.1) 0%, transparent 70%);
            border-radius: 50%;
        }
        
        .info-card:nth-child(2)::before {
            background: radial-gradient(circle, rgba(255, 234, 167, 0.3) 0%, transparent 70%);
        }
        
        .info-row {
            display: flex;
            justify-content: space-between;
            margin-bottom: 15px;
            font-size: 15px;
        }
        
        .info-label {
            color: #4a5568;
            font-weight: 500;
        }
        
        .info-value {
            color: #2d3748;
            font-weight: 600;
        }
        
        .customer-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 40px;
            margin-bottom: 40px;
        }
        
        .customer-card {
            background: white;
            padding: 30px;
            border-radius: 15px;
            box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
            border-top: 6px solid #00b894;
            position: relative;
            overflow: hidden;
        }
        
        .customer-card:nth-child(2) {
            border-top-color: #fdcb6e;
        }
        
        .customer-title {
            font-style: italic;
            font-weight: 700;
            color: #2d3748;
            margin-bottom: 20px;
            font-size: 16px;
            text-transform: uppercase;
            letter-spacing: 1px;
            position: relative;
        }
        
        .customer-title::after {
            content: '';
            position: absolute;
            bottom: -8px;
            left: 0;
            width: 50px;
            height: 3px;
            background: linear-gradient(45deg, #ff416c, #4ecdc4);
            border-radius: 2px;
        }
        
        .customer-detail {
            margin-bottom: 10px;
            font-size: 15px;
            color: #4a5568;
        }
        
        .items-table {
            width: 100%;
            border-collapse: collapse;
            margin-bottom: 20px;
            background: white;
            border-radius: 15px;
            overflow: hidden;
            box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
        }
        
        .items-table th {
            background: linear-gradient(135deg, #ff416c 0%, #ff4b2b 100%);
            color: white;
            padding: 16px 8px;
            text-align: center;
            font-weight: 600;
            font-size: 12px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
        }
        
        .items-table td {
            padding: 16px 8px;
            text-align: center;
            border-bottom: 1px solid #e2e8f0;
            font-size: 12px;
            color: #4a5568;
        }
        
        .items-table tr:nth-child(even) {
            background: linear-gradient(135deg, #fff5f5 0%, #fed7d7 100%);
        }
        
        .items-table tr:hover {
            background: linear-gradient(135deg, #f0fff4 0%, #c6f6d5 100%);
            transform: translateX(3px);
            transition: all 0.3s ease;
        }
        
        .items-table tr:last-child td {
            border-bottom: none;
            font-weight: 700;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
        }
        
        .amount-words {
            background: linear-gradient(135deg, #ffeaa7 0%, #fab1a0 100%);
            padding: 30px;
            border-radius: 15px;
            margin-bottom: 30px;
            border-left: 6px solid #e17055;
            box-shadow: 0 15px 35px rgba(225, 112, 85, 0.2);
            font-weight: 700;
            color: #d63031;
            font-size: 16px;
        }
        
        .bank-details {
            background: linear-gradient(135deg, #a8edea 0%, #fed6e3 100%);
            padding: 30px;
            border-radius: 15px;
            margin-bottom: 30px;
            border-left: 6px solid #4ecdc4;
            box-shadow: 0 15px 35px rgba(78, 205, 196, 0.2);
        }
        
        .bank-details p {
            margin: 8px 0;
            font-size: 15px;
            color: #2d3748;
            font-weight: 500;
        }
        
        .footer-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 40px;
            margin-top: 40px;
            padding-top: 40px;
            border-top: 4px solid #e2e8f0;
        }
        
        .footer-card {
            background: white;
            padding: 30px;
            border-radius: 15px;
            box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
            border-top: 6px solid #00b894;
        }
        
        .footer-card:nth-child(2) {
            border-top-color: #fdcb6e;
        }
        
        .section-title {
            font-size: 16px;
            font-weight: 700;
            color: #2d3748;
            margin-bottom: 20px;
            text-decoration: underline;
            text-transform: uppercase;
            letter-spacing: 0.5px;
        }
        
        .footer-card p {
            margin: 10px 0;
            font-size: 14px;
            color: #4a5568;
            line-height: 1.6;
        }
        
        .signature-area {
            border: 3px solid #fdcb6e;
            padding: 30px;
            margin-top: 20px;
            min-height: 80px;
            background: linear-gradient(135deg, #fff9e6 0%, #ffeaa7 100%);
            border-radius: 15px;
            margin-bottom: 20px;
        }
        
        .signature-label {
            font-weight: 700;
            color: #2d3748;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            font-size: 14px;
        }
        
        .disclaimer {
            text-align: center;
            font-size: 12px;
            color: #6b7280;
            margin-top: 30px;
            font-style: italic;
        }
        </style>
    </head>
    <body>
        <div class="container">
            <div class="header">
                <div class="header-pattern"></div>
                <p>GSTIN: <strong>${companyDetails?.gst || ""}</strong></p>
                <div class="copy-type">${copyType}</div>
            </div>
            
            <div class="content">
                <div class="company-section">
                    <div class="bill-type">${
                      invoice?.billType?.toUpperCase() || ""
                    }</div>
                    <div class="company-name">${
                      companyDetails?.businessName || ""
                    }</div>
                    <div class="company-details">${
                      companyDetails?.address || ""
                    }</div>
                    <div class="company-details">Mobile: ${
                      companyDetails?.phoneNumber || ""
                    }</div>
                    <div class="company-details">Email: ${
                      companyDetails?.email || ""
                    }</div>
                </div>
                
                <div class="info-grid">
                    <div class="info-card">
                        <div class="info-row">
                            <span class="info-label">Invoice No:</span>
                            <span class="info-value">${
                              invoiceNumber || ""
                            }</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">Date of Invoice:</span>
                            <span class="info-value">${getFormattedBillingDate(
                              invoiceDate
                            )}</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">State of Supply:</span>
                            <span class="info-value">${
                              stateOfSupply || ""
                            }</span>
                        </div>
                    </div>
                    <div class="info-card">
                        <div class="info-row">
                            <span class="info-label">Transport:</span>
                            <span class="info-value">${transport || ""}</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">Vehicle:</span>
                            <span class="info-value">${vehicle || ""}</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">Station:</span>
                            <span class="info-value">${station || ""}</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">E-Way Bill No:</span>
                            <span class="info-value">${eWayBillNo || ""}</span>
                        </div>
                    </div>
                </div>
                
                <div class="customer-grid">
                    <div class="customer-card">
                        <div class="customer-title">Billed to:</div>
                        <div class="customer-detail">${name || ""}</div>
                        <div class="customer-detail">${address || ""}</div>
                        <div class="customer-detail">Mob: ${
                          phoneNumber || ""
                        }</div>
                        <div class="customer-detail">GSTIN/UIN: ${
                          gst || ""
                        }</div>
                    </div>
                    <div class="customer-card">
                        <div class="customer-title">Shipped to:</div>
                        <div class="customer-detail">${name}</div>
                        <div class="customer-detail">${address}</div>
                        <div class="customer-detail">Mob: ${phoneNumber}</div>
                        <div class="customer-detail">GSTIN/UIN: ${gst}</div>
                    </div>
                </div>
                
                <table class="items-table">
                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th>Particulars</th>
                            <th>HSN Code</th>
                            <th>Warranty (months)</th>
                            <th>Qty.</th>
                            <th>Rate</th>
                            <th>Amount</th>
                            <th colspan="2">SGST Amount</th>
                            <th colspan="2">CGST Amount</th>
                            <th colspan="2">IGST Amount</th>
                            <th>Grand Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${
                          items
                            ?.map(
                              (item, index) => `
                            <tr>
                                <td>${index + 1}</td>
                                <td>${item.name}</td>
                                <td>${item.hsnCode}</td>
                                <td>${item.warranty || 0}</td>
                                <td>${+item.quantity || 0}</td>
                                <td>${
                                  Number.parseFloat(item.price).toFixed(2) || 0
                                }</td>
                                <td>${
                                  +item.amountBeforeTax.toFixed(2) || 0
                                }</td>
                                <td>${+item.sgst || 0}</td>
                                <td>${+item.sgstAmount.toFixed(2)}</td>
                                <td>${+item.cgst || 0}</td>
                                <td>${+item.cgstAmount.toFixed(2) || 0}</td>
                                <td>${+item.igst || 0}</td>
                                <td>${+item.igstAmount.toFixed(2) || 0}</td>
                                <td>${+item.grandTotal.toFixed(2) || 0}</td>
                            </tr>
                        `
                            )
                            .join("") || ""
                        }
                        <tr>
                            <td colspan="6">Total</td>
                            <td>${totalAmountBeforeTax.toFixed(2)}</td>
                            <td colspan="2">${totalSgstAmount.toFixed(2)}</td>
                            <td colspan="2">${totalCgstAmount.toFixed(2)}</td>
                            <td colspan="2">${totalIgstAmount.toFixed(2)}</td>
                            <td>${totalGrandTotal.toFixed(2)}</td>
                        </tr>
                    </tbody>
                </table>
                
                <table class="items-table">
                    <thead>
                        <tr>
                            <th>HSN/SAC</th>
                            <th>Tax Rate</th>
                            <th>Taxable Amount</th>
                            <th>CGST Amount</th>
                            <th>IGST Amount</th>
                            <th>SGST Amount</th>
                            <th>Total tax</th>
                        </tr>
                    </thead>
                    <tbody>
                    ${
                      groupedItems
                        ?.map(
                          (item, index) => `
                        <tr key=${index}>
                            <td>${item.hsnCode}</td>
                            <td>${(
                              Number(item?.sgst ?? 0) +
                              Number(item?.cgst ?? 0) +
                              Number(item?.igst ?? 0)
                            ).toFixed(2)}</td>
                            <td>${item.amountBeforeTax.toFixed(2)}</td>
                            <td>${item.cgstAmount.toFixed(2)}</td>
                            <td>${item.igstAmount.toFixed(2) || 0}</td>
                            <td>${item.sgstAmount.toFixed(2)}</td>
                            <td>${(
                              item.cgstAmount +
                              item.sgstAmount +
                              Number(item.igstAmount ?? 0)
                            ).toFixed(2)}</td>
                        </tr>
                    `
                        )
                        .join("") || ""
                    }
                        <tr>
                            <td>Totals</td>
                            <td></td>
                            <td>${totalAmountBeforeTax.toFixed(2)}</td>
                            <td>${totalCgstAmount.toFixed(2)}</td>
                            <td>${totalIgstAmount.toFixed(2)}</td>
                            <td>${totalSgstAmount.toFixed(2)}</td>
                            <td>${totalGrandTotal.toFixed(2)}</td>
                        </tr>
                    </tbody>
                </table>
                
                <div class="amount-words">${converter.convert(
                  totalGrandTotal
                )}</div>
                
                <div class="bank-details">
                    <p><strong>Bank Name:</strong> ${
                      companyDetails?.bankName
                    }</p>
                    <p><strong>IFSC Code:</strong> ${
                      companyDetails?.ifscCode
                    }</p>
                    <p><strong>Account Number:</strong> ${
                      companyDetails?.bankAccountNumber
                    }</p>
                    <p><strong>Branch:</strong> ${
                      companyDetails?.bankBranch
                    }</p>
                </div>
                
                <div class="footer-grid">
                    <div class="footer-card">
                        <div class="section-title">Terms & Conditions</div>
                        <p>E. & E.O.</p>
                        <p>1) Goods once sold will not be taken back</p>
                        <p>2) Interest @18% p.a. will be charged if the payment is not made within the stipulated time.</p>
                        <p>3) Subject to '${
                          companyDetails?.jurisdiction
                        }' Jurisdiction only.</p>
                    </div>
                    <div class="footer-card">
                        <div class="section-title">Receiver's Signature</div>
                        <div class="signature-area"></div>
                        <div class="signature-label">for ${
                          companyDetails?.businessName
                        }</div>
                        <div style="height: 30px;"></div>
                        <div class="signature-label">Authorised Signatory</div>
                    </div>
                </div>
                
                <div class="disclaimer">**this is computer generated invoice no signature required**</div>
            </div>
        </div>
    </body>
    </html>`;
};

export const getTemplateFunction = (templateName) => {
  return (
    TEMPLATE_LIST.find((template) => template.name === templateName)
      ?.function ?? invoicePDFTemplate
  );
};

export const TEMPLATE_LIST = [
  {
    name: "Classic",
    function: invoicePDFTemplate,
  },
  {
    name: "Modern",
    function: invoicePDFTemplate2,
  },
  {
    name: "Minimalist Modern",
    function: minimalistModernTemplate,
  },
  {
    name: "Minimalist Clean",
    function: minimalistCleanTemplate,
  },
  {
    name: "Creative Vibrant",
    function: colorfulVibrantTemplate,
  },
];

function newGroupItemsByHsnCode(items) {
  return items?.reduce((acc, item) => {
    const existingItem = acc.find((i) => i.hsnCode === item.hsnCode);
    if (existingItem) {
      existingItem.amountBeforeTax += item.grandTotal;
      existingItem.cgstAmount += item.cgstAmount;
      existingItem.igstAmount += item.igstAmount;
      existingItem.sgstAmount += item.sgstAmount;
    } else {
      acc.push({
        hsnCode: item.hsnCode,
        sgst: item.sgst,
        cgst: item.cgst,
        igst: item.igst,
        amountBeforeTax: item.grandTotal,
        cgstAmount: item.cgstAmount,
        igstAmount: item.igstAmount,
        sgstAmount: item.sgstAmount,
      });
    }
    return acc;
  }, []);
}

export const newInvoicePDFTemplate = (invoice, copyType) => {
  if (!invoice) return;
  const {
    companyDetails,
    invoiceNumber,
    invoiceDate,
    stateOfSupply,
    eWayBillNo = "",
    customerDetails,
    items,
    transport,
    vehicle,
    station,
    isPreview = false,
  } = invoice;

  const {
    address = "",
    phoneNumber = "",
    gst = "",
    name = "",
  } = customerDetails ?? {};
  const formattedBillingDate = new Date(invoiceDate).toLocaleDateString();

  let totalAmountBeforeTax = 0;
  let totalSgstAmount = 0;
  let totalCgstAmount = 0;
  let totalIgstAmount = 0;
  let totalGrandTotal = 0;

  items?.forEach((item) => {
    const totalTaxPercentage = +item.sgst + +item.cgst + +item.igst;

    // Calculate the tax amount included in the price
    const taxAmount = (totalTaxPercentage / 100) * +item.price;

    // Calculate the amount before tax
    item.amountBeforeTax = +item.price - taxAmount;
    item.sgstAmount = +item.quantity * ((item.price * +item.sgst) / 100);
    item.cgstAmount = +item.quantity * ((item.price * +item.cgst) / 100);
    item.igstAmount = +item.quantity * ((item.price * +item.igst) / 100);
    item.grandTotal = +item.quantity * +item.price;
    item.totalAmountBeforeTax = +item.quantity * +item.price;
    totalAmountBeforeTax += +item.amountBeforeTax * +item.quantity;
    totalSgstAmount += +item.sgstAmount;
    totalCgstAmount += +item.cgstAmount;
    totalIgstAmount += +item.igstAmount;
    totalGrandTotal += +item.grandTotal;
  });
  const groupedItems = newGroupItemsByHsnCode(items);

  const nonPreviewStyles = isPreview
    ? ""
    : `
  html, body {
    margin: 0;
    padding: 0;
  }
  body {
    font-family: 'Roboto', sans-serif;
    padding: 0px;
  }
`;

  return `<!DOCTYPE html>
  <html lang="en">
  <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>${name}</title>
      <style>
      .pdf-flex {
      display: -webkit-box;
      display: -moz-box;
      display: -ms-flexbox;

      flex-direction: column;
  }

  .box-parent {
      display: -webkit-box;
      display: -moz-box;
      display: -ms-flexbox;

      flex-direction: column;
  }

  .pdf-footer {
      display: -webkit-box;
      display: -moz-box;
      display: -ms-flexbox;
      width: 95%;
  }
  ${nonPreviewStyles}

          .container {
              border: 1px solid orange;
              padding: 10px;

              background-color: #f8f8f8;
          }
          .header {
            display: -webkit-box;

              align-items: center;
              font-size: 14px;
              width:100%;
              margin-bottom: 20px;

          }

          .header p {
              margin: 0;
          }

          .stamp {
              text-align: center;
              margin-bottom: 20px;
              font-size: 18px;
          }

          .stamp .para {
              font-weight:500;
              margin: 5px 0;
          }

          .company_name {
              color: red;
              font-size: 18px;
              margin-bottom: 10px;
          }

          .address {
              font-size: 14px;
              margin-bottom: 5px;
          }

          .box-parent {
              justify-content: space-between;
              margin-bottom: 20px;
          }

          .box-div {
              border: 1px solid black;
              width: 50%;
          }
          .list {
              padding: 10px;
              font-size: 14px;

              flex-direction: column;
          }

          .list i {
              font-style: italic;
              margin-bottom: 5px;
          }

          .list p {
              margin: 5px 0;
          }

          .table_container {
              text-align: center;
              margin-top: 16px;
          }

          table {
              font-family: Arial, Helvetica, sans-serif;
              border-collapse: collapse;
              width: 100%;
              font-size: 14px;
          }

          table th, table td {
              border: 1px solid #ddd;
              padding: 8px;
          }

          table th {
              background-color: #f2f2f2;
          }

          table tr:nth-child(even) {
              background-color: #f2f2f2;
          }

          table tr:hover {
              background-color: #ddd;
          }
          .bank_container
          {
              font-weight: 500;
              font-size: 14px;
          }
          .terms{
              border:1px solid black;
            padding: 10px;
              width:50%;
          }
          .terms_heading{
              text-decoration: underline;
              font-weight: 500;
              font-size: 14px;
          }
          .for_heading{
              font-weight: 500;
              font-size: 14px;
          }

          .signature_div{
              height: 20%;
              border-bottom: 1px solid black;
          }
          .disclaimer{
              border: 1px solid black;
              text-align: right;
              font-size: 14px;
              width: 95%;
              padding-right: 4px;
          }
          p{
              font-size: 14px;
          }
      </style>
  </head>
  <body>
      <div class="container">
          <div class="header">
              <p>GSTIN: <b>${companyDetails?.gst || ""}</b> </p>
              <p style="margin: auto;">${copyType}</p>
          </div>
          <hr>
          <div class="stamp">
              <p class="para">${invoice?.billType?.toUpperCase() || ""}</p>
              <p class="company_name para">${
                companyDetails?.businessName || ""
              }</p>
              <p class="address">${companyDetails?.address || ""}</p>
              <p class="address">Mobile Number : ${
                companyDetails?.phoneNumber || ""
              }</p>
              <p class="address">Email: ${companyDetails?.email || ""}</p>
          </div>
          <hr>
          <div class="box-parent">
              <div class="box-div pdf-flex">
                  <div class="list">
                      <p>Invoice No :</p>
                      <p>Date of Invoice :</p>
                      <p>State of Supply :</p>
                  </div>
                  <div class="list">
                      <p>${invoiceNumber || ""}</p>
                      <p>${
                        formattedBillingDate === "Invalid Date"
                          ? moment().format("DD/MM/YYYY")
                          : moment(formattedBillingDate).format("DD/MM/YYYY")
                      }</p>
                      <p>${stateOfSupply || ""}</p>
                  </div>
              </div>
              <div class="box-div pdf-flex">
                  <div class="list">
                      <p>Transport :</p>
                      <p>Vehicle :</p>
                      <p>Station :</p>
                      <p>E-Way Bill No :</p>
                  </div>
                  <div class="list">
                      <p>${transport || ""}</p>
                      <p>${vehicle || ""}</p>
                      <p>${station || ""}</p>
                      <p>${eWayBillNo || ""}</p>
                  </div>
              </div>
          </div>
          <div class="box-parent">
              <div class="box-div">
                  <div class="list">
                      <i>Billed to :</i>
                      <p>${name || ""}</p>
                      <p>${address || ""}</p>
                      <p>Mob : ${phoneNumber || ""}</p>
                      <p>GSTIN / UIN : ${gst || ""}</p>
                  </div>
              </div>
              <div class="box-div">
                  <div class="list">
                      <i>Shipped to :</i>
                      <p>${name}</p>
                      <p>${address}</p>
                      <p>Mob : ${phoneNumber}</p>
                      <p>GSTIN / UIN : ${gst}</p>
                  </div>
              </div>
          </div>
          <div class="table_container">
              <table>
                  <thead>
                      <tr>
                          <td>S.No</td>
                          <td>Particulars</td>
                          <td>HSN Code</td>
                          <td style="width: 10px;">Warranty (in months)</td>
                          <td>Qty.</td>
                          <td>Rate</td>
                          <td>Amount</td>
                          <td colspan="2">SGST Amount</td>
                          <td colspan="2">GGST Amount</td>
                          <td>Grand Total</td>
                      </tr>
                  </thead>
                  <tbody>
                      ${
                        items
                          ?.map(
                            (item, index) => `
                          <tr>
                              <td>${index + 1}</td>
                              <td>${item.name}</td>
                              <td>${item.hsnCode}</td>
                              <td>${item.warranty || 0}</td>
                              <td>${+item.quantity || 0}</td>
                              <td>${parseFloat(item.price).toFixed(2) || 0}</td>
                              <td>${+item.grandTotal.toFixed(2) || 0}</td>
                              <td>${+item.sgst || 0}%</td>
                              <td>${+item.sgstAmount.toFixed(2)}</td>
                              <td>${+item.cgst || 0}%</td>
                              <td>${+item.cgstAmount.toFixed(2) || 0}</td>
                              <td>${+item.igst || 0}%</td>
                              <td>${+item.igstAmount.toFixed(2) || 0}</td>
                              <td>${+item.grandTotal.toFixed(2) || 0}</td>
                          </tr>
                      `
                          )
                          .join("") || ""
                      }
                      <tr>
                          <td colspan="6">Total</td>
                          <td>${totalAmountBeforeTax.toFixed(2)}</td>
                          <td colspan="2">${totalSgstAmount.toFixed(2)}</td>
                          <td colspan="2">${totalCgstAmount.toFixed(2)}</td>
                          <td colspan="2">${totalIgstAmount.toFixed(2)}</td>
                          <td>${totalGrandTotal.toFixed(2)}</td>
                      </tr>
                  </tbody>
              </table>
          </div>
          <div class="table_container" id="2">
              <table>
                  <thead>
                      <tr>
                          <td>HSN/SAC</td>
                          <td>Tax Rate</td>
                          <td>Taxable Amount</td>
                          <td style="width: 10px;">CGST Amount</td>
                          <td style="width: 10px;">IGST Amount</td>
                          <td style="width: 10px;">SGST Amount</td>
                          <td>Total tax</td>
                      </tr>
                  </thead>
                  <tbody>
                  ${
                    groupedItems
                      ?.map(
                        (item, index) => `
                  <tr key=${index}>
                      <td>${item.hsnCode}</td>
                      <td>${(item.sgst + item.cgst + item.igst).toFixed(2)}</td>
                      <td>${item.amountBeforeTax.toFixed(2)}</td>
                      <td>${item.sgstAmount.toFixed(2)}</td>
                      <td>${item.cgstAmount.toFixed(2)}</td>
                      <td>${item.igstAmount.toFixed(2)}</td>
                      <td>${(
                        item.cgstAmount +
                        item.sgstAmount +
                        item.igstAmount
                      ).toFixed(2)}</td>
                  </tr>
              `
                      )
                      .join("") || ""
                  }
                      <tr>
                          <td>Totals</td>
                          <td></td>
                          <td>${totalAmountBeforeTax.toFixed(2)}</td>
                          <td>${totalCgstAmount.toFixed(2)}</td>
                          <td>${totalIgstAmount.toFixed(2)}</td>
                          <td>${totalSgstAmount.toFixed(2)}</td>
                          <td>${totalGrandTotal.toFixed(2)}</td>
                      </tr>
                  </tbody>
              </table>
          </div>
          <h5>${converter.convert(totalGrandTotal)}</h5>
          <div class="bank_container">
              <p>Bank Name : ${companyDetails?.bankName}</p>
              <p>IFSC Code : ${companyDetails?.ifscCode}</p>
              <p>Account Number : ${companyDetails?.bankAccountNumber}</p>
              <p>Branch : ${companyDetails?.bankBranch}</p>
          </div>
          <div class="pdf-footer">
              <div class="terms">
                  <h5 class="terms_heading">Terms & Conditions</h5>
                  <p>E. & E.O.</p>
                  <p>1) Goods once sold will not be taken back</p>
                  <p>2) Interest @18% p.a. will be charged if the payment is not made within the stipulated time.</p>
                  <p>3) Subject to '${
                    companyDetails?.jurisdiction
                  }' Jurisdiction only.</p>
              </div>
              <div class="terms">
                  <div class="signature_div">
                      <h5 class="terms_heading">Receiver's Signature</h5>
                      <p></p>
                      <p></p>
                      <p></p>
                      <p></p>
                  </div>
                  <div class="">
                      <h5 class="for_heading">for ${
                        companyDetails?.businessName
                      }</h5>
                      <div style="height: 60px;"></div>
                      <p class="for_heading">Authorised Signatory</p>
                  </div>
              </div>
          </div>
          <div class="pdf-footer">
              <p>**this is computer generated invoice no signature required**</p>
          </div>
      </div>
  </body>
  </html>`;
};

export const inventoryPDFTemplate = (inventoryData) => {
  const { companyDetails, _id: date, entries } = inventoryData;

  return `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Inventory Data</title>
    <style>
        body {
            font-family: Arial, sans-serif;
            margin: 20px;
        }
        .container {
            border: 1px solid orange;
            padding: 10px;
            background-color: #f8f8f8;
        }
        .header {
            display: flex;
            align-items: center;
            font-size: 14px;
            width: 100%;
            margin-bottom: 20px;
        }
        .header p {
            margin: 0;
        }
        .stamp {
            text-align: center;
            margin-bottom: 20px;
            font-size: 18px;
        }
        .stamp .para {
            font-weight: 500;
            margin: 5px 0;
        }
        .company_name {
            color: red;
            font-size: 18px;
            margin-bottom: 10px;
        }
        .address {
            font-size: 14px;
            margin-bottom: 5px;
        }
        .table_container {
            text-align: center;
            margin-top: 16px;
        }
        table {
            font-family: Arial, Helvetica, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 14px;
        }
        table th, table td {
            border: 1px solid #ddd;
            padding: 8px;
        }
        table th {
            background-color: #f2f2f2;
        }
        table tr:nth-child(even) {
            background-color: #f2f2f2;
        }
        table tr:hover {
            background-color: #ddd;
        }
        .date-row td {
            font-weight: bold;
            background-color: #f9f9f9;
        }
    </style>
</head>
<body>
    <div class="container">
        <div class="header">
            <p>Inventory Data</p>
        </div>
        <div class="stamp">
            <p class="para">${companyDetails?.businessName}</p>
            <p class="address">${companyDetails?.address}</p>
            <p class="address">Mobile Number: ${companyDetails?.phoneNumber}</p>
            <p class="address">Email: ${companyDetails?.email}</p>
            <p class="address">Date: ${date}</p>
        </div>
        <div class="table_container">
            <table>
                <thead>
                    <tr>
                        <th>ITEM</th>
                        <th>QUANTITY</th>
                        <th>STATUS</th>
                        <th>NOTE</th>
                    </tr>
                </thead>
                <tbody>
                 ${entries[0].items
                   .map(
                     (item) => `
                    <tr key=${item.itemId}>
                      <td>${item.name}</td>
                      <td>${item.itemQuantity}</td>
                      <td>${item.status}</td>
                      <td>${item.note}</td>
                    </tr>
                `
                   )
                   .join("")}
                </tbody>
            </table>
        </div>
    </div>
</body>
</html>
`;
};

export const getInputType = (type) => {
  if (type === "Text") {
    return "text";
  } else if (type === "Number") {
    return "Number";
  } else if (type === "Boolean") {
    return "checkbox";
  } else if (type === "Date") {
    return "date";
  } else if (type === "Time") {
    return "time";
  } else if (type === "Color") {
    return "color";
  } else if (type === "Select") {
    return "select";
  }
};

export function debounce(cb, delay) {
  let timeoutId;
  return function (...args) {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    timeoutId = setTimeout(() => {
      cb(...args);
    }, delay);
  };
}

export const formatDate = (date) => {
  const d = new Date(date);
  let month = "" + (d.getMonth() + 1);
  let day = "" + d.getDate();
  const year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
};
